import './App.css';
import {useEffect, useState} from "react";
import {supabase} from "./lib/supabaseClient";
import QRCode from "react-qr-code";


function App() {
    const [longUrl, setLongUrl] = useState('');
    const [shortUrl, setShortUrl] = useState('');
    const [copySuccess, setCopySuccess] = useState(''); // 用於顯示「已複製」提示

    // 1. 複製短網址文字
    const copyToClipboard = async () => {
        try {
            await navigator.clipboard.writeText(shortUrl);
            setCopySuccess('已複製！');
            setTimeout(() => setCopySuccess(''), 2000); // 2秒後隱藏提示
        } catch (err) {
            console.error('無法複製', err);
        }
    };

    // 2. 下載 QR Code 圖片
    const downloadQRCode = () => {
        const svg = document.getElementById("qr-code-download");
        const svgData = new XMLSerializer().serializeToString(svg);
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const img = new Image();

        img.onload = () => {
            canvas.width = img.width;
            canvas.height = img.height;
            ctx.fillStyle = "white"; // 確保背景是白的
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, 0, 0);
            const pngFile = canvas.toDataURL("image/png");

            const downloadLink = document.createElement("a");
            downloadLink.download = "qrcode.png";
            downloadLink.href = pngFile;
            downloadLink.click();
        };

        img.src = "data:image/svg+xml;base64," + btoa(unescape(encodeURIComponent(svgData)));
    };
    useEffect(() => {
        const handleRedirect = async () => {
            const path = window.location.pathname.split('/')[1];

            if (path && path !== "") {
                const {data, error} = await supabase
                    .from('urls')
                    .select('long_url')
                    .eq('short_url', path)
                    .maybeSingle();

                if (error) {
                    console.error("There was a problem:", error.message);
                    return;
                }

                // 只有在 data 存在且 data.long_url 有值時才跳轉
                if (data && data.long_url) {
                    window.location.replace(data.long_url);
                } else {
                    console.log("Can't find corresponding long_url: ", path);
                }
            }
        };
        handleRedirect();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!longUrl) return;

        // Check whether the long url is existed in database
        const {data: existingEntry, error: fetchError} = await supabase
            .from('urls')
            .select('short_url')
            .eq('long_url', longUrl)
            .maybeSingle(); // return object or null

        if (fetchError) {
            console.error('Fetch Error: ', fetchError.message);
            return;
        }
        if (existingEntry) {
            const existingShortUrl = `${window.location.origin}/${existingEntry.short_url}`;
            setShortUrl(existingShortUrl);
            setLongUrl('');
            return;
        }
        // Generate random short code
        const shortCode = Math.random().toString(36).substring(2, 7);
        const {error: insertError} = await supabase
            .from('urls')
            .insert([{
                short_url: shortCode,
                long_url: longUrl
            }]);
        if (insertError) {
            console.error('Store error', insertError.message);
            alert('database encountered an error');
            return;
        }

        const newShortUrl = `${window.location.origin}/${shortCode}`;
        setShortUrl(newShortUrl);
        setLongUrl('');
    };

    return (
        <div className="app-container">
            <div className="card">
                <h1>URL Shortener</h1>

                <form onSubmit={handleSubmit} className="input-group">
                    <input
                        type="url"
                        value={longUrl}
                        onChange={(e) => setLongUrl(e.target.value)}
                        placeholder="Your long url(https://...)"
                        required
                        className="style-input"
                    />
                    <button type="submit" className="generate-btn">
                        Generate
                    </button>
                </form>
                {/* 結果顯示區塊：只有當 shortUrl 有值時才顯示 */}
                {shortUrl && (
                    <div className="result-container fade-in">
                        <div className="link-section">
                            <p>你的短網址：</p>
                            <div className="link-wrapper">
                                <a href={shortUrl} target="_blank" rel="noreferrer" className="short-link">
                                    {shortUrl}
                                </a>
                                <button onClick={copyToClipboard} className="icon-btn">
                                    {copySuccess ? '✅' : '📋'}
                                </button>
                            </div>
                            {copySuccess && <span className="copy-toast">{copySuccess}</span>}
                        </div>

                        <div className="qr-section">
                            <div className="qr-frame">
                                <QRCode
                                    id="qr-code-download"
                                    value={shortUrl}
                                    size={140}
                                    bgColor={"#ffffff"}
                                    fgColor={"#A67B5B"}
                                    level={"M"}
                                />
                            </div>
                            <button onClick={downloadQRCode} className="download-btn">
                                下載 QR Code
                            </button>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
export default App;
